import type { GenericServiceParameters } from "~/core/models/GenericServiceParameters.interface";
import LxcError from "~/core/models/LxcError.class";
import type { UserDetailV2 } from "~/modules/user/models/UserDetailV2.interface";
import userAdministrationService from "~/modules/user/services/userAdministration.service";

export function useGetUser({
  businessUnitCode,
  organizationCode,
}: GenericServiceParameters<void>) {
  let service = userAdministrationService.getSuperAdministrationUser.bind(
    userAdministrationService,
  );
  if (organizationCode) {
    service = userAdministrationService.getOrganizationUser.bind(
      userAdministrationService,
    );
  } else if (businessUnitCode) {
    service = userAdministrationService.getBusinessUnitUser.bind(
      userAdministrationService,
    );
  }
  const isLoading = ref<boolean>(false);
  const error = ref<LxcError | null>(null);
  const result: Ref<UserDetailV2 | undefined> = ref<UserDetailV2 | undefined>(
    undefined,
  );

  async function getUser(userLogin: string): Promise<void> {
    error.value = null;
    isLoading.value = true;
    result.value = undefined;

    const response = await service({
      businessUnitCode,
      organizationCode,
      userLogin,
    });

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    getUser,
    error,
    isLoading,
    result,
  };
}
